import React from "react";
import { LegalPage } from "./LegalPage";

export default function Kayttoehdot() {
  return <LegalPage docKey="tos" testId="page-kayttoehdot" />;
}
